export const hasErrorExceededMaxQuantity = (errorMessageString?: string): boolean => {
  return !!errorMessageString?.includes('quantity-exceeds-item-maxQuantity');
};
export const hasErrorSubseededMinQuantity = (errorMessageString?: string): boolean => {
  return !!errorMessageString?.includes('quantity-subsides-item-minQuantity');
};
